
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_o71dh_193",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_o71dh_1",
  "root": "awsui_root_mx3cw_o71dh_215",
  "hidden": "awsui_hidden_mx3cw_o71dh_250",
  "alert-wrapper": "awsui_alert-wrapper_mx3cw_o71dh_298",
  "initial-hidden": "awsui_initial-hidden_mx3cw_o71dh_310",
  "header": "awsui_header_mx3cw_o71dh_315",
  "header-replacement": "awsui_header-replacement_mx3cw_o71dh_316",
  "action": "awsui_action_mx3cw_o71dh_320",
  "action-slot": "awsui_action-slot_mx3cw_o71dh_324",
  "action-button": "awsui_action-button_mx3cw_o71dh_325",
  "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_o71dh_329",
  "text": "awsui_text_mx3cw_o71dh_361",
  "icon": "awsui_icon_mx3cw_o71dh_368",
  "message": "awsui_message_mx3cw_o71dh_371",
  "action-wrapped": "awsui_action-wrapped_mx3cw_o71dh_375",
  "icon-size-medium": "awsui_icon-size-medium_mx3cw_o71dh_379",
  "icon-size-big": "awsui_icon-size-big_mx3cw_o71dh_383",
  "icon-size-normal": "awsui_icon-size-normal_mx3cw_o71dh_387",
  "content": "awsui_content_mx3cw_o71dh_391",
  "content-replacement": "awsui_content-replacement_mx3cw_o71dh_392",
  "dismiss": "awsui_dismiss_mx3cw_o71dh_396",
  "dismiss-button": "awsui_dismiss-button_mx3cw_o71dh_401",
  "type-error": "awsui_type-error_mx3cw_o71dh_405",
  "type-warning": "awsui_type-warning_mx3cw_o71dh_413",
  "type-success": "awsui_type-success_mx3cw_o71dh_421",
  "type-info": "awsui_type-info_mx3cw_o71dh_429"
};
  